__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "@vip/root-config-ui";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@datadog/browser-rum", "4.26.0", function() { return __webpack_require__.e(401).then(function() { return function() { return __webpack_require__(68401); }; }); });
			register("@okta/okta-auth-js", "4.9.2", function() { return __webpack_require__.e(388).then(function() { return function() { return __webpack_require__(5388); }; }); });
			register("@okta/okta-react", "4.1.0", function() { return Promise.all([__webpack_require__.e(978), __webpack_require__.e(927), __webpack_require__.e(216), __webpack_require__.e(518)]).then(function() { return function() { return __webpack_require__(26978); }; }); });
			register("@spreetail/meta-8", "1.0.0-rc.54", function() { return Promise.all([__webpack_require__.e(7), __webpack_require__.e(796), __webpack_require__.e(182), __webpack_require__.e(927), __webpack_require__.e(819), __webpack_require__.e(925)]).then(function() { return function() { return __webpack_require__(65796); }; }); });
			register("@vip-tools/mfe-shared-types", "1.2.3", function() { return Promise.all([__webpack_require__.e(927), __webpack_require__.e(831)]).then(function() { return function() { return __webpack_require__(29612); }; }); });
			register("i18next", "21.10.0", function() { return __webpack_require__.e(671).then(function() { return function() { return __webpack_require__(23671); }; }); });
			register("react-dom", "17.0.2", function() { return Promise.all([__webpack_require__.e(153), __webpack_require__.e(927)]).then(function() { return function() { return __webpack_require__(10153); }; }); });
			register("react-error-boundary", "3.1.4", function() { return Promise.all([__webpack_require__.e(927), __webpack_require__.e(637)]).then(function() { return function() { return __webpack_require__(93471); }; }); });
			register("react-i18next", "11.18.6", function() { return Promise.all([__webpack_require__.e(327), __webpack_require__.e(927)]).then(function() { return function() { return __webpack_require__(84327); }; }); });
			register("react-query", "3.39.2", function() { return Promise.all([__webpack_require__.e(698), __webpack_require__.e(927), __webpack_require__.e(819)]).then(function() { return function() { return __webpack_require__(96698); }; }); });
			register("react-router-dom", "5.3.4", function() { return Promise.all([__webpack_require__.e(892), __webpack_require__.e(927), __webpack_require__.e(840)]).then(function() { return function() { return __webpack_require__(37892); }; }); });
			register("react-spring", "9.5.5", function() { return Promise.all([__webpack_require__.e(7), __webpack_require__.e(927), __webpack_require__.e(819), __webpack_require__.e(236)]).then(function() { return function() { return __webpack_require__(39236); }; }); });
			register("react", "17.0.2", function() { return __webpack_require__.e(289).then(function() { return function() { return __webpack_require__(74412); }; }); });
			register("styled-components", "5.3.6", function() { return Promise.all([__webpack_require__.e(971), __webpack_require__.e(927)]).then(function() { return function() { return __webpack_require__(96971); }; }); });
			initExternal(84960);
			initExternal(80723);
			initExternal(53541);
			initExternal(11255);
			initExternal(21462);
			initExternal(10315);
			initExternal(96923);
			initExternal(93506);
			initExternal(97514);
			initExternal(59388);
			initExternal(49480);
			initExternal(22275);
			initExternal(91473);
			initExternal(90400);
			initExternal(70573);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};